import { useCurrentConversation } from '@rsos/reduxDataStore/src/features/alerts/hooks';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import {
  AlertChatBoxContainer,
  CHAT_HEADER_HEIGHT,
  TalkJSContainer,
} from '../AlertChatBox/AlertChatBox.styles';
import TalkJSPrivilegedChatbox from './TalkJSPrivilegedChatbox';

interface AlertPrivilegedChatboxProps {
  chatBoxHeight: string;
  isChatBoxVisible?: boolean;
  hasChatEnded?: boolean;
}

const AlertPrivilegedChatbox = ({
  chatBoxHeight,
  isChatBoxVisible,
  hasChatEnded,
}: AlertPrivilegedChatboxProps) => {
  const currentAlert = useSelectedAlert();
  const alertConversation = useCurrentConversation();

  const selectedAlertID = currentAlert?.alert_id;
  const alertConversationID = alertConversation?.privileged_conversation?.id;

  const alertActionsHeight = hasChatEnded
    ? CHAT_HEADER_HEIGHT
    : CHAT_HEADER_HEIGHT + 40;

  return (
    <AlertChatBoxContainer isChatBoxVisible={isChatBoxVisible ?? false}>
      {selectedAlertID && alertConversationID && (
        <TalkJSContainer
          chatBoxHeight={chatBoxHeight}
          alertActionsHeight={`${alertActionsHeight}px`}
          isChatBoxVisible={isChatBoxVisible ?? false}
        >
          <TalkJSPrivilegedChatbox
            isChatBoxVisible={isChatBoxVisible ?? false}
          />
        </TalkJSContainer>
      )}
    </AlertChatBoxContainer>
  );
};

export default AlertPrivilegedChatbox;
